import { cssVar } from './cssVar'

export const motionDurationTokens = {
  instant: 80,
  fast: 120,
  preview: 150,
  base: 200,
  slow: 320,
  emphasis: 520,
  shell: 650,
  shimmer: 1200,
}

export const motionDurationVarTokens = {
  instant: cssVar('--app-motion-duration-instant'),
  fast: cssVar('--app-motion-duration-fast'),
  preview: cssVar('--app-motion-duration-preview'),
  base: cssVar('--app-motion-duration-base'),
  slow: cssVar('--app-motion-duration-slow'),
  emphasis: cssVar('--app-motion-duration-emphasis'),
  shell: cssVar('--app-motion-duration-shell'),
  shimmer: cssVar('--app-motion-duration-shimmer'),
  homeHero: cssVar('--app-motion-duration-home-hero'),
  homeInput: cssVar('--app-motion-duration-home-input'),
  homeUsageChip: cssVar('--app-motion-duration-home-usage-chip'),
  homeUsageBlock: cssVar('--app-motion-duration-home-usage-block'),
}
